import { createReducer, on } from "@ngrx/store";
import { HeaderState, OperatorOption } from "./header.models";
import { loadLocations, loadMenuItemsSuccess, locationsLoadSuccess, notificationsLoadSuccess} from "./header.actions";
import * as operatorsActions from '../operators/operators.actions';

export const initialHeaderState: HeaderState = {
    locations: [],
    notifications: [],
    selectedLocation: null,
    menuItems: []
}

export const headerReducer = createReducer(
    initialHeaderState,
    on(operatorsActions.LoadOperatorsSuccess, (state, {operators}) => ({
        ...state,
        operators: operators.map(x => {
            return { id: x.id, name: x.name } as OperatorOption
        })
    })),
    on(loadLocations, (state, {operator}) => ({
        ...state,
        selectedOperator: operator
    })),
    on(locationsLoadSuccess, (state, {locations}) => ({
        ...state,
        locations
    })),
    on(notificationsLoadSuccess, (state, {notifications}) => ({
        ...state,
        notifications
    })),
    on(loadMenuItemsSuccess, (state, {menuItems}) => ({
        ...state,
        menuItems
    }))
);